/**
 * Re-export of the shared PromotionalBannerGrid component for the storefront renderer.
 * The base component (render + fields + defaults) lives in
 * `@launchstore/shared-puck`. The renderer uses it as-is — no
 * editor-specific field widgets.
 *
 * See launchstore-shared/src/puck/components/homepage/PromotionalBannerGrid/ for source.
 */
import { PromotionalBannerGrid as SharedPromotionalBannerGrid } from '@launchstore/shared-puck';

export const PromotionalBannerGrid: any = SharedPromotionalBannerGrid;
export type {
  PromotionalBannerGridProps,
  PromotionalBannerItem,
} from '@launchstore/shared-puck';
export default PromotionalBannerGrid;
